<template>
  <div class="SendGrid">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <send-grid-tab @clickedTab="selectedTab"></send-grid-tab>
      <send-grid-filter-bar @selectedObj="setSelectedFilterBarObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="viewBtnClicked" v-if="parseInt(this.currentSelectedTab) === 1"></send-grid-filter-bar>
      <send-grid-summary-report-filter-bar @selectedObj="setSelectedFilterBarObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="viewBtnClicked" v-if="parseInt(this.currentSelectedTab) === 2"></send-grid-summary-report-filter-bar>
      <hr width="94%" size="10px">
      <div class="row sendGridList margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4 margin-left-1point5Perc">
          <send-grid-list v-if="showEmailList" v-bind:responseObj="getReportArr" v-bind:currentTab="getCurrentlySelectedTab"></send-grid-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>   
  </div>
</template>
<script>
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import SendGridTab from '@/components/reports/send_grid/SendGridTab'
import SendGridFilterBar from '@/components/reports/send_grid/SendGridFilterBar'
import SendGridSummaryReportFilterBar from '@/components/reports/send_grid/SendGridSummaryReportFilterBar'
import SendGridList from '@/components/reports/send_grid/SendGridList'
import CopyrightElement from '@/components/CopyrightElement'
import AlertBox from '@/components/AlertOverlay'
import ErrorPage from '@/pages/Error'
import { constants } from '@/utils/constants'
import { reportService } from '@/server-util/report-service'
import csvHelper from '@/utils/csv-helper'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedEmailObj: null,
      selectedStartDate: null,
      selectedEndDate: null,
      currentSelectedTab: 1,
      showAlertDialog: false,
      errorMsg: false,
      showSpinner: false,
      showExportButton: true,
      showEmailList: false,
      reportArr: [],
      isViewBtnClicked: false,
      isExportBtnClicked: false
    }
  },
  components: {
    'send-grid-tab': SendGridTab,
    'send-grid-filter-bar': SendGridFilterBar,
    'send-grid-list': SendGridList,
    'Copyright-Element': CopyrightElement,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'send-grid-summary-report-filter-bar': SendGridSummaryReportFilterBar,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    setSelectedFilterBarObj (values) {
      // AK: Update selected details in parent file also
      this.selectedEmailObj = values.emailObj
      this.selectedStartDate = values.startDate
      this.selectedEndDate = values.endDate
    },
    selectedTab (value) {
      // AK: As soon as user changed Tab then hide report list
      if (parseInt(this.currentSelectedTab) !== value) {
        this.showEmailList = false
      }
      // AK: Update Currently selected Tab
      this.currentSelectedTab = value
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getSendGridStatsReport()
            break
          case 2:
            this.getSendGridSummaryReport()
            break
        }
      }
    },
    viewBtnClicked (value) {
      this.isViewBtnClicked = value
      if (value) {
        // AK: Issue server call to get list
        switch (parseInt(this.currentSelectedTab)) {
          case 1:
            this.getSendGridStatsReport()
            break
          case 2:
            this.getSendGridSummaryReport()
            break
        }
      }
    },
    getSendGridStatsReport: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== '') {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        reportService
          .getSendGridStats(
            storeObj.state.access_token,
            this.selectedEmailObj,
            this.selectedStartDate,
            this.selectedEndDate
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.reportArr = responseObj.data
              if (_this.reportArr.length === 0) {
                _this.showEmailList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.bindServerResponse()
              }
              // console.log('getSendGridStatsReport >>> ' + JSON.stringify(responseObj.data))
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.currentlyShowingSpinner = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    getSendGridSummaryReport: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== '') {
        // _this.showSpinner = true
        this.$store.state.isLoading = true
        reportService
          .getSendGridStatsSummary(
            storeObj.state.access_token,
            this.selectedStartDate,
            this.selectedEndDate
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.reportArr = responseObj.data
              if (_this.reportArr.length === 0) {
                _this.showEmailList = false
                _this.showAlertDialog = true
                _this.errorMsg = 'No reports found.'
              } else {
                _this.bindServerResponse()
              }
              // console.log('getSendGridStatsSummary >>> ' + JSON.stringify(responseObj.data))
            } else {
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.currentlyShowingSpinner = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    checkAndExecuteOperation: function () {
      if (this.isViewBtnClicked && !this.isExportBtnClicked) {
        this.showEmailList = true
      } else if (!this.isViewBtnClicked && this.isExportBtnClicked) {
        this.exportCSVReport()
      } else if (this.isViewBtnClicked && this.isExportBtnClicked) {
        this.showEmailList = true
        this.exportCSVReport()
      }
    },
    exportCSVReport: function () {
      // AK: Used to download Send Grid CSV file
      var fileName = ''
      switch (parseInt(this.currentSelectedTab)) {
        case 1:
          fileName = 'SendGridStatsReport(' + this.selectedEmailObj + ')'
          var columnAlias = ['Date', 'Processed', 'Dropped', 'Delivered', 'Deferred', 'Bounces', 'Opens', 'Clicks', 'Spam Reports', 'Unsubscribed', 'Group Unsubscribes', 'Group Resubscribes']
          break
        case 2:
          fileName = 'SendGridSummaryReport(' + this.selectedStartDate + '-' + this.selectedEndDate + ')'
          columnAlias = ['Sender', 'Processed', 'Dropped', 'Delivered', 'Deferred', 'Bounces', 'Opens', 'Clicks', 'Spam Reports', 'Unsubscribed', 'Group Unsubscribes', 'Group Resubscribes']
          break
      }
      var columnRespKey = ['StatDate', 'Processed', 'Dropped', 'Delivered', 'Deferred', 'Bounces', 'Opens', 'Clicks', 'SpamReports', 'Unsubscribes', 'GroupUnsubscribes', 'GroupResubscribes']
      return csvHelper.export(this.getReportArr, columnRespKey, columnAlias, fileName)
    },
    bindServerResponse: function () {
      var tempRespArr = []
      for (var i = 0; i < this.reportArr.length; i++) {
        var dateToShow = ''
        if (this.currentSelectedTab === 1) {
          // AK: if current selected Tab is 1 i.e. Stats reports then bind date as first param and for last record bind Total
          if ((i + 1) < (this.reportArr.length)) {
            dateToShow = dmAdminUtils.getMonthInWordFromDate(this.reportArr[i].StatDate)
          } else {
            dateToShow = this.reportArr[i].SenderEmail
          }
        } else {
          // AK: Binf record as it
          dateToShow = this.reportArr[i].SenderEmail
        }
        var obj = {
          StatDate: dateToShow,
          Processed: this.reportArr[i].Processed,
          Dropped: this.reportArr[i].Dropped,
          Delivered: this.reportArr[i].Delivered,
          Deferred: this.reportArr[i].Deferred,
          Bounces: this.reportArr[i].Bounces,
          Opens: this.reportArr[i].Opens,
          Clicks: this.reportArr[i].Clicks,
          SpamReports: this.reportArr[i].SpamReports,
          Unsubscribes: this.reportArr[i].Unsubscribes,
          GroupUnsubscribes: this.reportArr[i].GroupUnsubscribes,
          GroupResubscribes: this.reportArr[i].GroupResubscribes
        }
        tempRespArr.push(obj)
      }
      this.reportArr = tempRespArr
      console.log('this.reportArr >>> ' + JSON.stringify(this.reportArr))
      this.checkAndExecuteOperation()
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    },
    getReportArr: {
      get: function () {
        return this.reportArr
      }
    },
    getCurrentlySelectedTab: {
      get: function () {
        return this.currentSelectedTab
      }
    }
  },
  name: 'SendGrid'
}
</script>

<style scoped>
.SendGrid {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.margin-left-1point5Perc{
  margin-left:1.5% !important;
}
.margin-right-1point5Perc{
  margin-right:1.5% !important;
}
.width-97Point4{
  width:97.4% !important;
}
.sendGridList{
  min-height: 57vh;
}
</style>


// WEBPACK FOOTER //
// src/pages/SendGrid.vue